import styled, { css } from 'styled-components';
import { SelectContainer } from '../../CustomSelect/style';

export const QuizGlobalWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};

  .quiz-info {
    background: linear-gradient(178.31deg, #e9f3ff -11.67%, #f2f8ff 117.4%);
    padding: 10px 22px 23px;

    .duration {
      display: flex;
      align-items: center;
      gap: 35px;

      svg {
        margin-left: 7px;
        margin-top: -2px;
        stroke: ${(props) => props.theme.colors.textPrimary};
      }
    }
  }
`;

export const QuizWrapper = styled.div`
  & .correct {
    & label {
      background-color: ${(props) => props.theme.colors.success} !important;
      color: black !important;
      &[data-checked='true'] {
        box-shadow: 0px 0px 6px ${(props) => props.theme.colors.textPrimary};
      }
    }
  }

  & .wrong {
    & label {
      background-color: ${(props) => props.theme.colors.fail} !important;
      color: black !important;
      &[data-checked='true'] {
        box-shadow: 0px 0px 6px ${(props) => props.theme.colors.textPrimary};
      }
    }
  }

  &.resume {
    border: none;
  }

  .news {
    margin-left: auto;
    margin-bottom: 16px;
  }
`;
export const AnswerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 10px;
  label {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  button {
    width: 105px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: block;
  }

  &.resume {
    display: flex;
    justify-content: space-between;
    align-items: end;
    color: ${(props) => props.theme.colors.link};
    margin-bottom: 30px;
    cursor: pointer;

    .answer:not(:first-child) {
      margin-top: 12px;
    }
  }
`;

export const Answer = styled.div`
  label {
    margin-left: -10px;
  }

  &:last-child {
    margin-bottom: 57px;
  }

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      & .quiz {
        cursor: not-allowed;
      }
    `}
`;

export const ResultMessage = styled.div`
  padding: 24px 0 16px;
  color: ${(props) => props.theme.colors.textPrimary};
`;

export const TabsWrapper = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: ${(props) => props.theme.colors.link};

  > div {
    width: 100%;
  }

  ${SelectContainer} {
    width: unset;
  }

  div[class*='-control'] {
    border: none;
    width: fit-content;
  }

  div[class*='singleValue'] {
    color: ${(props) => props.theme.colors.link} !important;
    text-align: end;
  }

  div[class*='menu'] {
    min-width: 200px;
    right: 0;
  }
`;

export const ResultsWrapper = styled.div`
  padding: 60px 32px 32px;

  .result-msg-wrapper {
    display: flex;
    justify-content: center;
    gap: 32px;

    svg {
      stroke: ${(props) => props.theme.colors.fail};

      &.icon-face-smile {
        stroke: ${(props) => props.theme.colors.success};
      }
    }
  }

  .btn-wrapper {
    margin-top: 16px;
  }
`;

export const ProgressResult = styled.div`
  margin-top: 84px;
  padding-bottom: 143px;
  display: flex;
  justify-content: center;
  border-bottom: 0.5px solid #646464;

  .progress-wrapper {
    width: 80%;
    max-width: 800px;
    position: relative;
  }

  .answers {
    position: absolute;
    top: -4px;
    &.min {
      left: -45px;
    }
    &.max {
      right: -45px;
    }
  }
`;

export const Target = styled.div`
  position: absolute;
  top: 0;
  left: calc(${({ left }) => left}% - 26px);
  width: 52px;
  height: 52px;
  border-radius: 100%;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.link};
  transform: translateY(-25%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TargetMsg = styled.div`
  position: absolute;
  top: 45px;
  left: calc(${({ left }) => left}% - 26px);
  width: fit-content;
`;
